module.exports = __webpack_public_path__ + "26e40a45c7b897d68d30f0b7ed82d98e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/ui-carousel/fonts/ui-carousel.svg
 ** module id = 209
 ** module chunks = 0
 **/